// Central place for launch-time values that change without a code change.
//
// APP_STORE_URL: paste the App Store link once the app is approved
// (https://apps.apple.com/app/id<APPLE_ID>). While it is empty the home page
// shows "coming to the App Store" copy instead of a download button.
export const APP_STORE_URL = '';

export const SUPPORT_EMAIL = 'contact@sparrowtek.com';

export const PRIVACY_POLICY_EFFECTIVE_DATE = 'September 6, 2026';
